import HeaderData from '../../components/Header/Header.data';
import FooterData from '../../components/Footer/Footer.data';

export default {
    header: HeaderData,
    siteSetting: {
        ...FooterData,
    },
};
